import { API_URL, API_LIMIT } from 'config';
import { LiteralUnion } from 'models';
import { makeAPICall } from './api';

export type Status = LiteralUnion<
    | 'idle'
    | 'inactive'
    | 'preparing'
    | 'executing'
    | 'testing'
    | 'error'
    | 'resetting'
>;

export declare namespace API {
    export interface Alert {
        id: number;
        antenna: number;
        satellite: number;
        type: string;
        details: string;
        level: number;
        start_time: string;
        stop_time: string;
        acknowledged: boolean;
        cleared: boolean;
        created: string;
    }
}

export interface Alert {
    id: number;
    antenna: null | number;
    satellite: null | number;
    type: string;
    details: string;
    level: number;
    start_time: Date;
    stop_time: Date;
    acknowledged: boolean;
    cleared: boolean;
    created: Date;
}

const ALERTS_ROUTE = '/alert';

export const mapAPIToAlert = ({
    //antenna,
    //satellite,
    start_time,
    stop_time,
    created,
    ...rest
}: API.Alert): Alert => ({
    ...rest,
    //antenna: antenna ? mapAPIToAntenna(antenna) : null,
    //satellite: satellite ? mapAPIToSatellite(satellite) : null,
    start_time: new Date(start_time),
    stop_time: new Date(stop_time),
    created: new Date(created),
});

export const listAlerts = makeAPICall<
    { results: Alert[]; totalCount: number },
    void,
    { results: API.Alert[]; count: number }
>(
    () => ({
        url: `${API_URL}${ALERTS_ROUTE}/?ordering=-created`,
    }),
    (data) => ({
        results: data.results.map(mapAPIToAlert),
        totalCount: data.count,
    }),
);

export interface APIparams {
    pageNum: number;
}

export const getNextAlerts = makeAPICall<
    Alert[],
    APIparams,
    { results: API.Alert[] }
>(
    ({ pageNum }) => ({
        url: `${API_URL}${ALERTS_ROUTE}/?limit=${API_LIMIT}&offset=${
            API_LIMIT * pageNum
        }&ordering=-created`,
    }),
    (data) => data.results.map(mapAPIToAlert),
);

export const updateAlertAck = makeAPICall<
    Alert,
    { id: number; acknowledged: boolean },
    API.Alert
>(
    ({ id, acknowledged }) => ({
        url: `${API_URL}${ALERTS_ROUTE}/${id}/`,
        requestData: {
            body: JSON.stringify({ id, acknowledged }),
            method: 'PATCH',
        },
    }),
    (data) => mapAPIToAlert(data),
);

export const getAlertById = makeAPICall<Alert, { id: number }, API.Alert>(
    ({ id }) => ({
        url: `${API_URL}${ALERTS_ROUTE}/${id}/`,
    }),
    (alert) => mapAPIToAlert(alert),
);
